const APIBaseUrl = process.env.REACT_APP_AUTHORIZATIONSERVER_URL.replace('authorizationserver', 'instanceMgmt')
const APIBaseUrlToken = APIBaseUrl + 'token'
const APIBaseUrlEndpoints = APIBaseUrl + 'api/'
const AuthorizationserverTokenUrl = process.env.REACT_APP_AUTHORIZATIONSERVER_URL + 'token'

export const APIEndpointsIMGMT = {
  washInstallcheck: 'wash/installcheck',
  washInitcheck: 'wash/initcheck',
  washSettings: 'wash/settings',
  washStations: id =>{
    if (!id) {
      return 'wash/stations'
    }
    return `wash/stations/${id}`
  },
  washJobs: stationId =>{
    if (!stationId) {
      return 'wash/jobs'
    }
    return `wash/jobs?stationId=${stationId}`
  },
  washServices: 'wash/services',
  washSalestypes: 'wash/salesTypes',
  washReportJobTypes : 'wash/reportJobTypes',
  washOpenItems : 'wash/open/items',
  washOpenItemsCounter : 'wash/open/itemsCounter',
  washScanCode: (rfid) =>{
    return `wash/scan/${rfid}`
  },
  washOpenJobsForScanCode: (rfid, stationId) =>{
    if (!stationId) {
      return `wash/scan/${rfid}/job`
    }
    return `wash/scan/${rfid}/job?stationId=${stationId}`
  },
}
let result = { APIBaseUrl, APIBaseUrlToken, APIBaseUrlEndpoints, APIEndpointsIMGMT, AuthorizationserverTokenUrl }
export default result
